import React from "react";
import {Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import { updateStatusProduct,fetchProduct } from "appRedux/actions/Product";

class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      productStatus:''
    }
    }

    showModal = () => {
      console.log(this.props.recording);
      this.setState({
        visible: true,
        productStatus:''
      });
    };

 

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El producto ha cambiado su estado éxitosamente.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al eliminar el producto.',
      });
    }
  };
  
 
  render() {
    let labelActionStatus;
    let productStatus;
    let classButtonName;
    
    let actionButton;
    if(this.props.recording.status===1){
      labelActionStatus=<p>¿Está seguro de desactivar el producto {this.props.recording.name}?</p>
      productStatus=0;
        classButtonName="icon icon-divider"
        actionButton="desactivar"
      }else{
        labelActionStatus=<p>¿Está seguro de activar el producto {this.props.recording.name}?</p>
        classButtonName="icon icon-add"
        productStatus=1;
        actionButton="activar"
      
      }
     
        
    return (
      <div>
        <Button type="info" onClick={this.showModal}>{actionButton}</Button>
        <Modal
          okText = {actionButton}
          cancelText = "Salir"
            title="Estado de producto"
            visible={this.state.visible}
            onOk={() => {
              //console.log(this.props.recording.id);
              this.props.updateStatusProduct(this.props.recording.id,productStatus, () => { this.props.fetchProduct( ); });
              this.onNotification('success');
            }}
            onCancel={() => {
              this.props.fetchProduct( );
              this.setState({visible: false});
            }}
          >
         {labelActionStatus}
        </Modal>
      </div>
    );
  }
}


function mapStateToProps({products}) {
  return {
    products
  }
}
export default connect(mapStateToProps, {fetchProduct, updateStatusProduct} )(ModalDelete);


// WEBPACK FOOTER //
// ./src/routes/main/Products/ModalDelete.js